import {combineReducers} from 'redux';

import Sanitizers from '/redux/store/sanitizers';
import {log} from '/util/console.util';

import abacus from './abacus.reducer';
import apiError from './apiError.reducer';
import auth from './auth.reducer';
import autoLogin from './biometrics.reducer';
import candidate from './candidate.reducer';
import client from './client.reducer';
import coach from './coach.reducer';
import currentUser from './currentUser.reducer';
import launchSequence from './launchSequence.reducer';
import loading from './loading.reducer';
import metric from './metric.reducer';
import myTeams from './MyTeams.reducer';
import navigation from './navigation.reducer';
import {network} from './network.reducer';
import popover from './popover.reducer';
import {remoteConfig} from './remoteConfig.reducer';
import report from './report.reducer';
import {search} from './search.reducer';
import testingOptions from './testingOptions.reducer';
import volumePerformanceReport from './volumePerformanceReport.reducer';
import watchList from './watchList.reducer';
import webImageOverride from './webImageOverride.reducer';

const combinedReducer = combineReducers({
  launchSequence,
  navigation,
  currentUser,
  coach,
  client,
  candidate,
  metric,
  report,
  network,
  apiError,
  abacus,
  auth,
  remoteConfig,
  testingOptions,
  loading,
  autoLogin,
  search,
  popover,
  myTeams,
  watchList,
  volumePerformanceReport,
  webImageOverride,
});

// TODO: Implement a more robust logging control configuration.
// TODO: In additional to conditional logging, we should also defer the logging output.
const LOG_ACTIONS = false;

const rootReducer = (state: any, action: any) => {
  if (LOG_ACTIONS) {
    log('------------------------------------');
    log('state', Sanitizers.stateSanitizer(state));
    log('action', Sanitizers.actionSanitizer(action));
  }

  const newState = combinedReducer(state, action);

  if (LOG_ACTIONS) {
    log('newState', Sanitizers.stateSanitizer(newState));
  }

  return newState;
};

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
